module.exports = {"development":{"websocketUrl":"ws://localhost:3001","restUrl":"http://localhost:3000"},"localhost":{"websocketUrl":"ws://localhost:3001","restUrl":"http://localhost:3001"},"staging":{"websocketUrl":"ws://13.113.40.19:3004","restUrl":"http://13.113.40.19:3004"},"production":{"websocketUrl":"wss://base_url","restUrl":"https://base_url"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 3125
// module chunks = 0